<template>
    <v-dialog v-model="shows" max-width="90%" scrollable>
        <template #activator="{ attrs, on }">
            <v-card v-bind="attrs" v-on="on" flat tile max-height="240" color="transparent" class="common-metatag-list-item-code__activator">
                <v-card-text class="px-4 py-3">
                    <code class="common-metatag-list-item-code__code">{{ item.code }}</code>
                </v-card-text>
                <div class="common-metatag-list-item-code__more d-flex justify-center align-end">
                    <v-card outlined class="my-3 px-3 py-2 rounded-lg subtitle-2">더 보기</v-card>
                </div>
            </v-card>
        </template>
        <v-card>
            <v-card-title>
                경로 "{{ item.path }}" 에 대한 코드
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <code class="common-metatag-list-item-code__code">{{ item.code }}</code>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { initCommonMetatag } from "@/store/metatags";

export default {
    props: {
        item: { type: Object, default: initCommonMetatag },
    },
    data: () => ({
        shows: false,
    }),
};
</script>

<style lang="scss" scoped>
.common-metatag-list-item-code {
    &__activator {
        position: relative;
        overflow: hidden;
        cursor: pointer;
    }
    &__code {
        display: block;
        padding: 0;
        background: transparent !important;
        color: inherit;
        box-shadow: none;
        font-size: 0.75rem;
        white-space: pre-line;
        word-break: break-all;
    }
    &__more {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, transparent, white);
    }
}
</style>
